var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('sidebar-item',{attrs:{"link":{name: _vm.$t('Агентства'),  path: `/company/agent`, icon: 'vip_icon icon_agency'}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }